import { Backdrop, Box, Card, CardContent, Grid, Stack, MenuItem } from '@mui/material';
import React, { useEffect, useImperativeHandle, useState, forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';

import ApiService from '../../../../services/ApiService';
import CustomToastContainer, { CustomDatePicker, Selection } from '../../../../components/ui';
import ButtonDailyReportCash from './Buttons/ButtonDailyReportCash';
import HeaderInfo from '../../../../components/Components/HeaderInfo';
import LoadingSpinner from '../../../../components/Components/LoadingSpinner';
import ModalConfirmation from '../../../../components/Modals/ModalConfirmation';
import { setDateFormat } from '../../../../utils/date';
import { PrintExcel, PrintPDF } from '../../../../utils/reusableFunction';

const DailyReportCash = forwardRef((props, ref) => {
    const [isLoadingPrint, setIsLoadingPrint] = useState(false);
    const history = useNavigate();
    const [period, setPeriod] = useState('');
    const [perCompany, setPerCompany] = useState(1);
    const paramRegUserAccess = 'regUserAccess/regUserAccess';
    const [DataRegUserAccess, setDataRegUserAccess] = useState([]);
    const CustomCompanyList = [
        { id: 1, name: 'Per Company' },
        { id: 2, name: 'Regional Company' }
    ];

    const [isModalConfirmation, setIsModalConfirmation] = useState(false);
    const [titleModalConfirmation, setTitleModalConfirmation] = useState('');
    const [titleConfirmation, setTitleConfirmation] = useState('');

    const BreadcrumbsItems = [
        { label: 'Majura', link: '/Majura', style: '' },
        { label: 'Daily Report Cash', link: '/Majura/DailyReportCashReport', style: { color: '#0087C2', fontWeight: '700' } },
    ];

    useImperativeHandle(ref, () => ({
        localSave() {

        }
    }));

    useEffect(() => {
        document.title = 'Daily Report Cash - ' + JSON.parse(localStorage.getItem('branchName'));
        getDataAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getDataAccess = () => {
        setIsLoadingPrint(true);
        let params = [];
        let pId = 0;
        let listMenu = JSON.parse(localStorage.getItem("dataMenuCode")) || [];
        let hasAccess = false

        const indexMenu = listMenu.findIndex((elm) => elm.code === 'OSHOR')
        if (indexMenu !== -1) {
            pId = listMenu[indexMenu].id
            hasAccess = true
        }

        if (hasAccess) {
            params = [
                ...params,
                { 'attr': 'permissionId', 'value': '' + pId },
                { 'attr': 'userId', 'value': '' + JSON.parse(localStorage.getItem("userId")) },
                { 'attr': 'roleId', 'value': '' + JSON.parse(localStorage.getItem("roleId")) }
            ]
            ApiService.IdentityPostByPage(paramRegUserAccess, 'PAGE', 1, 100, params, [])
                .then((response) => {
                    if (response.data.code === 200) {
                        setDataRegUserAccess(response.data.data.userAccess);

                        getDateNow();
                    }
                })
                .catch(function (error) {
                    console.error('error saat fetch', error)
                    history('/Majura');
                })
        }
        else {
            history('/Majura');
        }
    }

    function getDateNow() {
        setIsLoadingPrint(false);
        setDateFormat(new Date(), setPeriod);
    }

    const selectCustomCompany = (CustomCompany, setCustomCompany) => {
        return (
            <Selection
                id='0'
                fullWidth={true}
                label="Custom Company"
                value={CustomCompany}
                placeholder={'Select Custom Company'}
                onChange={(e) => setCustomCompany(e.target.value)}
                disabled
            >
                {
                    CustomCompanyList.map((data) => (
                        <MenuItem sx={{ fontSize: '12px' }} id={data.id} key={data.id} value={data.id}>
                            {data.name}
                        </MenuItem>
                    ))
                }
            </Selection>
        )
    }

    const handleClickConfirmation = () => {
        if (isModalConfirmation === false) {
            setIsModalConfirmation(true);
        }
        else {
            setIsModalConfirmation(false);
        }
    }

    function ConfirmationDRC() {
        if (titleConfirmation === 'Print PDF') {
            PrintReport("pdf");
        }
        else if (titleConfirmation === 'Print Excel') {
            PrintReport("xls");
        }
        setIsModalConfirmation(false);
    }

    const PrintData = () => {
        setTitleConfirmation('Print PDF')
        setTitleModalConfirmation('Daily Report Cash');
        handleClickConfirmation();
    };

    const PrintExcelData = () => {
        setTitleConfirmation('Print Excel')
        setTitleModalConfirmation('Daily Report Cash');
        handleClickConfirmation();
    }

    const PrintReport = (code) => {
        setIsLoadingPrint(true);
        let perCompany = '';
        if (perCompany !== 0) {
            perCompany = 'Multi'
        }

        let params = [
            {
                "attr": "closingDate",
                "value": period
            }
        ];

        let reportLink = 'Reports/Finance/Print/Cashier/DailyReportCashReport/DailyReportCashReport/PrintDailyReportCash?typeReport=' + code;
        if (code === 'pdf') {
            PrintPDF(setIsLoadingPrint, 'Daily Report Cash', reportLink, params);
        }
        else {
            PrintExcel(setIsLoadingPrint, 'Daily Report Cash', reportLink, params);
        }

    };

    const ButtonComponents = () => {
        return (
            <ButtonDailyReportCash
                PrintData={PrintData} PrintExcel={PrintExcelData}
                DataRegUserAccess={DataRegUserAccess}
            />
        )
    }

    return (
        <Box className='w-100' sx={{ width: '100%', p: 3 }}>
            <CustomToastContainer />
            <Grid container spacing={0} direction="column">
                <HeaderInfo
                    title={'Daily Report Cash'}
                    isJobType={false}
                    BreadcrumbsItems={BreadcrumbsItems}
                    ButtonComponents={ButtonComponents}
                />

                <Grid item xs={12} style={{ 'width': '100%', 'borderRadius': '5px' }}>
                    <div style={{ marginTop: '24px' }}>
                        <Grid
                            container
                            spacing={'32px'}
                        >
                            <Grid
                                item
                                xl={6}
                                lg={6}
                                sm={6}
                                xs={12}
                            >
                                <Card component="div" style={{ borderRadius: '12px', backgroundColor: '#F2F2F2', padding: '16px 24px' }}>
                                    <CardContent>
                                        <Stack spacing={'16px'} direction="row">
                                            {selectCustomCompany(perCompany, setPerCompany)}

                                            <CustomDatePicker
                                                label='As Per Date'
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                                value={period}
                                                onChange={(e) => setPeriod(e)}
                                                type='date'
                                                formControlProps={{
                                                    sx: {
                                                        width: '100%',
                                                    }
                                                }}
                                            />
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>

            {
                isModalConfirmation && (
                    <ModalConfirmation
                        isModal={isModalConfirmation}
                        titleModal={titleModalConfirmation}
                        title={titleConfirmation}
                        handleClick={handleClickConfirmation}
                        ConfirmationData={ConfirmationDRC}
                    />
                )
            }

            {
                isLoadingPrint && (
                    <Backdrop
                        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={isLoadingPrint}
                    >
                        <LoadingSpinner />
                    </Backdrop>
                )
            }
        </Box>
    )
})

export default DailyReportCash